<!-- InformationComponent.vue - final with cast (v5) -->
<template>
  <div class="information-menu">
    <div class="information-container">
      <img class="information-svg" src="../assets/SVG/INFORMATION.svg" alt="INFORMATION">
    </div>
    <div class="info-close-button-container">
      <img :src="require('../assets/SVG/X-BLACK.svg')" alt="Close" @click="infoclosePage">
    </div>
    <div class="information-content">

    <transition name="fade" mode="out-in">
      <img :src="selectedImage" :key="selectedImage" alt="photo" class="information-img" />
    </transition>

<h1 class="title">映画『イバラ・夜の祈り』特別上映イベント<br>第二回目開催決定！</h1>
<div class="event-details">
  <p class="details-text">
先ほど終了した6月の上映イベントが好評につき、急遽第二回目の開催が決定しました。<br>
会場は前回と同じく、今年オープンしたばかりの今最も熱いシネマサロン・シモキタ地下室です。<br>
上映後には、映画史家の伊藤彰彦さんをお迎えして、堀江実監督とのトークショーも行います。<br>
  </p>

  <p class="details-text">
    <strong>上映作品</strong><br>
    『イバラ・夜の祈り』（2023年／65分）<br>
    公式HP：<a href="http://minoruhorie.com/ibara/" target="_blank">http://minoruhorie.com/ibara/</a>
  </p>

  <p class="details-text">
    <strong>出演：</strong> 小林エレキ・白波多カミン・米澤成美・瀧澤綾音・藤一平
  </p>

  <p class="details-text">
    <strong>監督：</strong> 堀江実<br>
    <strong>脚本：</strong> ヤマザキアキラ<br>
  </p>

  <p class="details-text">
  <strong>日時：</strong>
  7月26日（土）<br>
  <span class="time-block">13:30-14:35 映画上映</span><br>
  <span class="time-block">14:40-15:30 トークショー：伊藤彰彦（映画史家）、堀江実（本作監督）</span>
</p>
  <p class="details-text">
    <strong>場所：</strong> シモキタ地下室<br>
    （京王井の頭線下北沢駅西口徒歩9分／小田急線下北沢駅東口徒歩11分）<br>
    東京都世田谷区大原1-11-3 B1F<br>
    <a href="https://shimokitaug.tokyo/" target="_blank">https://shimokitaug.tokyo/</a><br>
  </p>

  <p class="details-text">
    <strong>料金：</strong> 1,600円（予約当日共通・全席自由）<br>
    ※料金は当日現金払い<br>
    ※開場は上映15分前
  </p>

  <p class="details-text">
    <strong>予約フォーム：</strong>
    <a href="https://forms.gle/yjgcJHaMXjjeRmun6" target="_blank">https://forms.gle/yjgcJHaMXjjeRmun6</a><br>
    ※こちらからの返信メールをもって予約完了となります。<br>
    24時間以内に連絡がない場合はお問い合わせください。
  </p>

  <p class="details-text">
    <strong>企画・主催：</strong> プラネットナインピクチャーズ<br>
    <strong>問合せ先：</strong> <a href="mailto:p9pfilm@gmail.com">p9pfilm@gmail.com</a>
  </p>
</div>

<div class="director-profile">
  <h3 class="sub-title">登壇者プロフィール</h3>

  <p class="details-text"><strong>伊藤彰彦 略歴</strong><br>
  1960年愛知県生まれ。映画史家。98年、シナリオ作家協会大伴昌司賞佳作奨励賞受賞。初めての著作『映画の奈落 北陸代理戦争事件』が第37回講談社ノンフィクション賞の最終候補作となる。主な著作として『無冠の男 松方弘樹伝』『最後の角川春樹』『仁義なきヤクザ映画史』『なぜ80年代映画は私たちを熱狂させたのか』など。一方で、2011年には『明日泣く』（色川武大原作、内藤誠監督）の製作と脚本、2018年には『スティルライフオブメモリーズ』（矢崎仁司監督）のプロデューサーと脚本も務めている。</p>

  <p class="details-text"><strong>堀江実 略歴</strong><br>
  1980年東京生まれ。早稲田大学在学中、柳町光男監督に学ぶ。2003年には長谷川和彦監督の助監督候補に選出され、以降数年に渡って劇映画『連合赤軍』の脚本執筆に参加。20代半ばより本格的に映画制作を開始し、近年はドキュメンタリー映画を立て続けに発表している。代表作に『みずち』(13)、『首くくり栲象の庭』(16)など。現在、コロナ禍を経た「東京の生活」を主題とした連作短編集『東京生息現代』を鋭意制作中。</p>
</div>

    </div>
  </div>
</template>
<script>
import { previousPath } from '../router'; 
export default {
  data() {
    return {
      imageList: [
        require('../assets/infomation_images/sub01.jpg'),
        require('../assets/infomation_images/sub02.jpg'),
        require('../assets/infomation_images/sub03.jpg'),
        require('../assets/infomation_images/sub04.jpg'),
        require('../assets/infomation_images/sub05.jpg'),
        require('../assets/infomation_images/sub06.jpg'),
        require('../assets/infomation_images/sub07.jpg'),
        require('../assets/infomation_images/sub08.jpg')
      ],
      selectedImage: null,
      slideshowInterval: null
    };
  },
  mounted() {
    // 初期表示
    this.changeImage();

    // 10秒ごとに画像を変更
    this.slideshowInterval = setInterval(this.changeImage, 10000);

    window.scrollTo(0, 0);
  },
  beforeUnmount() {
    // コンポーネント破棄時に interval を解除
    clearInterval(this.slideshowInterval);
  },
  methods: {
    infoclosePage() {
      if (previousPath && previousPath !== '/') {
        this.$router.push(previousPath); // 遷移元に戻る
      } else {
        this.$router.push('/'); // 直リンクなどはトップへ
      }
    },
    changeImage() {
      let newImage;
      do {
        newImage = this.imageList[Math.floor(Math.random() * this.imageList.length)];
      } while (newImage === this.selectedImage);
      this.selectedImage = newImage;
    }
  }
};
</script>

<style scoped>
.information-menu {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  background-color: #f4f4f4;
}
.information-container {
  width: 80%;
  max-width: 640px;
  margin-bottom: 20px;
  text-align: center;
}
.information-content {
  width: 90%;
  max-width: 880px;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: justify;
}
.title {
  font-family: "Zen Kaku Gothic New", sans-serif;
  font-weight: bold;
  color: black;
  text-align: left;
  margin-bottom: 1rem;
  margin-top: 0.25rem;
  font-size: 2rem;
}
.sub-title {
  font-size: 1.2rem;
  font-family: "Zen Kaku Gothic New", sans-serif;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
  color: #555;
}
.time-block {
  display: inline-block;
  margin-left: 3em;
}
.details-text {
  margin-bottom: 0.5rem;
  font-family: "Shippori Mincho", serif;
  font-size: 1rem;
  color: #444;
  line-height: 1.75em;
}
a {
  color: #0066cc;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
.information-svg {
  margin-top: 10vh;
}

.information-img {
  width: 70%;
  max-width: 860px;
  height: auto; 
  aspect-ratio: 16 / 9;
  object-fit: cover;
  display: block;
  margin-bottom: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}


.info-close-button-container {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 1000;
}
.info-close-button-container img {
  width: 45px;
  height: 45px;
  cursor: pointer;
}
@media screen and (max-width: 480px) {
  .information-content {
    padding: 15px;
    border-radius: 8px;
  }
  .title {
    font-size: 1.2rem;
    font-weight: bold;
  }
  .sub-title {
    font-size: 1rem;
    font-weight: bold;
  }
  .details-text {
    font-size: 0.9rem;
  }
  .info-close-button-container img {
    width: 35px;
    height: 35px;
  }
  .information-svg {
    margin-top: 15vh;
    width: 60%;
  }
}
</style>

